import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BeneficiaryDetailsChanges } from '../../../beneficiaries/models/beneficiary-details-changes';
import { BeneficiarySubmissionUtils } from '../../../beneficiaries/utils/beneficiary-submission-utils';
import { CommonModule } from '@angular/common';
import { SubmissionDetailComponent } from '../submission-detail-grid/submission-detail/submission-detail.component';
import { PreviousNotApplicablePipe } from '../../pipes/previous-not-applicable.pipe';
import { SubmissionStateEnum } from '../../../../models/users/enum/submission-state-enum';

@Component({
  selector: 'app-beneficiary-details-organization-changes',
  standalone: true,
  imports: [CommonModule, SubmissionDetailComponent, PreviousNotApplicablePipe],
  templateUrl: './beneficiary-details-organization-changes.component.html',
  styleUrls: [
    '../../../../views/shared/components/member-beneficiary-submission-details/member-beneficiary-submission-details.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeneficiaryDetailsOrganizationChangesComponent implements OnChanges {
  @Input() beneficiaryChanges!: BeneficiaryDetailsChanges;

  private _formattedOrgChanges = new BehaviorSubject<BeneficiaryDetailsChanges | null>(null);
  public formattedOrgChanges$ = this._formattedOrgChanges as Observable<BeneficiaryDetailsChanges>;

  private _formattedContactChanges = new BehaviorSubject<BeneficiaryDetailsChanges | null>(null);
  public formattedContactChanges$ = this._formattedContactChanges as Observable<BeneficiaryDetailsChanges>;

  private _hasOrgChanges = new BehaviorSubject<boolean>(false);
  public hasOrgChanges$ = this._hasOrgChanges as Observable<boolean>;

  private _hasContactChanges = new BehaviorSubject<boolean>(false);
  public hasContactChanges$ = this._hasContactChanges as Observable<boolean>;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.beneficiaryChanges) {
      const orgChanges = new BeneficiaryDetailsChanges();
      const contactChanges = new BeneficiaryDetailsChanges();

      const isOrgKey = (key: string) =>
        key === 'organizationName' || key === 'organizationBusinessNumber' || key?.startsWith('address');

      const isContactKey = (key: string) => key === 'firstName' || key === 'lastName' || key === 'phoneNumber';

      const filterChanges = (changeList: any[], predicate: (key: string) => boolean) =>
        changeList
          .filter(change => predicate(change.label))
          .map(c => BeneficiarySubmissionUtils.formatBeneficiaryDetailsChanges(c));

      orgChanges.new = filterChanges(this.beneficiaryChanges.new, isOrgKey);
      orgChanges.previous = filterChanges(this.beneficiaryChanges.previous, isOrgKey);

      contactChanges.new = filterChanges(this.beneficiaryChanges.new, isContactKey);
      contactChanges.previous = filterChanges(this.beneficiaryChanges.previous, isContactKey);

      this._formattedOrgChanges.next(orgChanges);
      this._formattedContactChanges.next(contactChanges);

      this._hasOrgChanges.next(orgChanges.new.some(c => c.hasChanged));
      this._hasContactChanges.next(contactChanges.new.some(c => c.hasChanged));
    }
  }

  protected readonly SubmissionStateEnum = SubmissionStateEnum;
}
